<template>
    <span
      @click="generateQR({type, id, language})"
      :class="addClass"
    >
      <slot name="text" v-if="hasTextSlot" ></slot>
      <span v-else >{{ $t('GenerarQR') }}</span>
    </span>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    export default {
        props: {
            type: {
                type: String,
                required: true
            },
            id: {
                type: Number,
                required: true
            },
            classSpan: {
                type: String
            }
        },
        components: {
        },
        computed: {
            ...mapGetters({
                language: 'getCurrentLanguage'
            }),
            hasTextSlot () {
                return !!this.$slots.text
            },
            addClass () {
                let classes = '';
                if (this.classSpan) {
                    classes = this.classSpan;
                }
                return classes;
            }
        },
        data () {
            return {
            }
        },
        created () {

        },
        mounted () {

        },
        methods: {
            ...mapActions({
                generateQR: 'generateQR'
            }),
        }
    }
</script>
<style>
</style>
